<template>
	<div>
		<v-row align="center" class="mb-2">
			<v-col cols="12" sm="8">
				<h1 class="headline mb-0">Inhaallessen</h1>
				<div class="caption text--secondary">
					Uw aanmeldingen voor inhaallessen. Nieuwe aanmeldingen wachten op goedkeuring van de coördinator.
				</div>
			</v-col>
			<v-col cols="12" sm="4" class="text-sm-right">
				<v-btn color="primary" depressed :to="{ path: '/main/inhaallessen/nieuw' }">
					<v-icon left>mdi-plus</v-icon>
					Nieuwe aanmelding
				</v-btn>
			</v-col>
		</v-row>

		<v-alert
			v-if="errorMessage"
			type="error"
			border="right"
			colored-border
			elevation="2"
			class="mb-4"
		>{{ errorMessage }}</v-alert>

		<v-card class="elevation-2">
			<v-data-table
				:headers="headers"
				:items="rows"
				:loading="loading"
				:items-per-page="10"
			>
				<template v-slot:item.reg_date="{ item }">
					{{ formatDate(item.reg_date) }}
				</template>
				<template v-slot:item.coordinator_approval="{ item }">
					<v-chip
						small
						:color="isApproved(item) ? 'success' : 'warning'"
						dark
					>
						{{ isApproved(item) ? "Goedgekeurd" : "In behandeling" }}
					</v-chip>
				</template>
				<template v-slot:no-data>
					Nog geen inhaallessen aangemeld.
				</template>
			</v-data-table>
		</v-card>
	</div>
</template>

<script>
export default {
	name: "inhaallessen",
	data: function() {
		return {
			loading: false,
			errorMessage: null,
			rows: [],
			headers: [
				{ text: "Datum", value: "reg_date" },
				{ text: "Schooljaar", value: "tbl_sys_schoolyear.name" },
				{ text: "Periode", value: "tbl_sys_periode.name" },
				{ text: "Deelkwalificatie", value: "tbl_sys_subject.name" },
				{ text: "Module", value: "tbl_teacher_subject_class.module" },
				{ text: "Motivatie", value: "description" },
				{ text: "Status", value: "coordinator_approval" }
			]
		};
	},
	created() {
		this.loadRows();
	},
	methods: {
		isApproved(item) {
			return !!Number(item && item.coordinator_approval);
		},
		formatDate(value) {
			if (!value) return "—";
			var d = new Date(value);
			if (isNaN(d.getTime())) return String(value).slice(0, 10);
			var day = String(d.getDate()).padStart(2, "0");
			var month = String(d.getMonth() + 1).padStart(2, "0");
			var year = d.getFullYear();
			return day + "-" + month + "-" + year;
		},
		async loadRows() {
			this.loading = true;
			this.errorMessage = null;
			try {
				this.rows = await this.$store.dispatch("fetchStudentOvertakeClasses");
			} catch (err) {
				this.errorMessage =
					(err && err.message) || "Inhaallessen konden niet worden geladen.";
				this.rows = [];
			} finally {
				this.loading = false;
			}
		}
	}
};
</script>
